import "core-js/modules/es7.string.pad-start";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.search";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins2";
import addAppCustom from "./components/addAppCustom";
import customDetails from "./components/customDetails.vue";
import config from "@/config/index";
import { allocation_log, history_log, history_log_del, getdownloadtoken, area_list } from "@/api/jingxiaoshang";
import { jingxiaoshang } from "@/api/api_url.js";
import { getcurrDate } from "@/libs/util";
import { get_effective_router, get_effective_router_data } from "@/api/chuku";
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this;

    return {
      areaData: [],
      form_filter: {
        page: 1,
        page_size: 15,
        did: null,
        date: null,
        cate: 2
      },
      allowedDates: [],
      options: {},
      //共用的查询与重置
      topButtonList: [{
        name: this.$t("query"),
        type: "primary",
        method: this.search
      }, {
        name: this.$t("reset"),
        type: "error",
        method: this.reset
      }],
      reqBase: {
        page: 1,
        page_size: 15,
        po: "",
        time_end: "",
        time_start: "",
        prev_time: ""
      },
      status: true,
      //是否企业认证
      tableDataList: [],
      getPageTotal: 0,
      operationButtonList: [{
        name: "查看",
        type: "text",
        icon: "",
        method: this.details
      }],
      columnsheader: [// {
      //   title: this.$t("serialnumber"),
      //   key: "id",
      //   align: "center",
      //   width: 80,
      // },
      {
        title: this.$t("tripTimestart"),
        key: "start_time_str",
        align: "left",
        minWidth: 120,
        tree: true
      }, {
        title: this.$t("tripTimeend"),
        key: "end_time_str",
        align: "left",
        minWidth: 120,
        tree: true
      }, {
        title: this.$t("startaddress"),
        key: "shop_name",
        align: "left",
        minWidth: 120,
        tree: true,
        render: function render(h, _ref) {
          var row = _ref.row;
          return h("div", row.start_point.addr);
        }
      }, {
        title: this.$t("endaddress"),
        key: "shop_name",
        align: "left",
        minWidth: 120,
        tree: true,
        render: function render(h, _ref2) {
          var row = _ref2.row;
          return h("div", row.end_point.addr);
        }
      }, {
        title: this.$t("operation"),
        key: "explain",
        align: "center",
        width: 300,
        render: function render(h, _ref3) {
          var row = _ref3.row;
          var arr = [];
          arr.push(h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: "3px",
              color: "#2d8cf0"
            },
            props: {
              size: "small",
              type: "text"
            },
            on: {
              click: function click() {
                _this2.edit(row);
              }
            }
          }, _this2.$t("details")));
          return h("div", arr);
        }
      }]
    };
  },
  props: {
    reducehe: {},
    code: {}
  },
  components: {
    customDetails: customDetails
  },
  computed: {},
  methods: {
    changeTime: function changeTime(val) {
      console.log('valval', val);
      this.$set(this.form_filter, "date", val);
    },
    init: function init() {
      var _this3 = this;

      if (!this.form_filter.date) {
        console.log("wode参数1", this.form_filter);
        this.form_filter.date = getcurrDate();
        this.reqBase.date = this.form_filter.date;
      }

      if (this.$route.query.did) {
        this.reqBase.did = this.$route.query.did;
        this.form_filter.did = this.$route.query.did;
      }

      this.tableLoading = true;
      console.log("wode参数", this.form_filter);

      if (this.form_filter.date && this.form_filter.did) {
        get_effective_router_data(this.form_filter).then(function (res) {
          console.log("wode参数", res);
          _this3.tableDataList = res.body.list;
          _this3.tableLoading = false;
        });
      }
    },
    search: function search() {
      this.form_filter.type = "";
      this.onSearch(this.form_filter);
    },
    reset: function reset() {
      this.form_filter = {
        date: null
      };
      this.form_filter.type = "";
      this.search();
    },
    edit: function edit(row) {
      var routeData = this.$router.push({
        path: "/trajectory",
        query: {
          did: this.form_filter.did,
          time: row.start_time_str.split(" ")[0]
        }
      });
      window.open(routeData.href, "_self");
    },

    /**
     * 删除
     */
    del: function del(row) {
      var vm = this;
      this.$Modal.confirm({
        title: this.$t('删除'),
        content: this.$t('您确定要删除序号为') + row.id + '?',
        loading: true,
        onOk: function onOk() {
          var _this = this;

          history_log_del({
            id: row.id
          }).then(function (res) {
            console.log(res);
            var msg = res.errorMsg;

            if (res.result === 0) {
              var _msg = res.errorMsg;
              vm.$Message.success(_msg);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(msg);
              _this.buttonLoading = false;
            }
          });
        }
      });
    }
  },
  mounted: function mounted() {},
  created: function created() {
    var _this4 = this;

    get_effective_router({
      did: this.$route.query.did
    }).then(function (res) {
      _this4.allowedDates = res.body.date_info || [];
      _this4.form_filter.date = res.body.date_last;
      _this4.options = {
        disabledDate: function disabledDate(date) {
          var year = date.getFullYear();
          var month = String(date.getMonth() + 1).padStart(2, "0");
          var day = String(date.getDate()).padStart(2, "0");
          var formattedDate = "".concat(year, "-").concat(month, "-").concat(day);
          return !_this4.allowedDates.some(function (entry) {
            return entry.date === formattedDate;
          });
        }
      };

      _this4.init();
    });
  }
};